import { SUPPORT_FORM_EN_HREF } from 'modules/static-pages/constants';

import styles from './guidelines.module.scss';

const GuidelinesContentEn = () => (
  <div className={styles.wrapper}>
    <div className={styles.box}>
      <div className={styles.icon}>
        <img
          src="https://res.cloudinary.com/zehitomo/image/upload/v1653985864/ok7jiaoxkdn5t54fwt8n.svg"
          alt="icon"
        />
        <div>For Clients</div>
      </div>
      <div className={styles.text}>
        <div>
          Respect the Zehitomo community: We trust you to be responsible. Don&#39;t abuse the site!
        </div>
        <div>Don&#39;t cross the line. Do not post inappropriate content.</div>
        <div>Be kind and courteous. Don&#39;t be rude.</div>
        <div>
          Confirm Client&#39;s expectations. Know your skills, set clear expectations and only do
          tasks you know that you can accomplish to the Client’s satisfaction.
        </div>
        <div>Do your best to answer client questions as clearly and completely as possible.</div>
        <div>Be punctual and be prepared.</div>
        <div>Be reliable: follow-up with Clients and complete the jobs you are hired for.</div>
        <div>Be professional in all interactions.</div>
        <div>Safety first. If in doubt, don&#39;t do it.</div>
        <div>
          When in doubt, contact Customer Support via
          <a
            className={styles.contact}
            href={SUPPORT_FORM_EN_HREF}
            rel="noopener noreferrer"
            target="_blank"
          >
            Contact Form
          </a>
          .
        </div>
      </div>
    </div>
    <div className={styles.box}>
      <div className={styles.icon}>
        <img
          src="https://res.cloudinary.com/zehitomo/image/upload/v1653985966/qbololh3198rpyxrlcwf.svg"
          alt="icon"
        />
        <div>For Pros</div>
      </div>
      <div className={styles.text}>
        <div>
          Respect the Zehitomo community: We trust you to be responsible. Don&#39;t abuse the site!
        </div>
        <div>Don&#39;t cross the line. Do not post inappropriate content.</div>
        <div>Be kind and courteous. Don&#39;t be rude.</div>
        <div>Refrain from requesting Pros for inappropriate or potentially offensive reasons.</div>
        <div>Do your best to answer Pro questions as clearly and completely as possible.</div>
      </div>
    </div>
  </div>
);

export default GuidelinesContentEn;
